export enum SnapshotChunkType {
  Start,
  Chunk,
  End
}
